'use client';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import VideoThumbnail from '@repo/ui/src/components/VideoThumbnail';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';

interface Props {
  youtubeLink: YoutubeLinkProps;
}

export const VideoContainer = ({ youtubeLink }: Props) => {
  const { push } = useModal(ModalID.video);
  const imgUrl = buildImageSrc(
    youtubeLink.uploadedThumbnail?.[0],
    500,
    16,
    9,
    youtubeLink.thumbnailUrl,
  );
  return (
    <div className="general-half-split-yt-container px-auto lg:px-8">
      <button type="button" onClick={() => push({ youtubeLink })}>
        <VideoThumbnail
          title={youtubeLink?.name}
          imgUrl={imgUrl}
          duration={`${youtubeLink?.duration ?? ''}`}
        />
      </button>
    </div>
  );
};
